import React from 'react'
import { View, StyleSheet } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import PropTypes from 'prop-types'
import SkeletonContent from 'react-native-skeleton-content'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import QuickNumberCard from '../QuickNumberCard'

const QuickNumbers = ({ quickNumbers, loading }) => {
  const { isDesktop } = usePlatforms()
  const styles = useStyles(isDesktop)
  const navigation = useNavigation()

  const skeleton = {
    firstContainer: {
      flex: 1,
      flexDirection: 'row'
    },
    secondContainer: {
      flex: 1,
      flexDirection: 'row'
    },
    card: {
      flex: 1,
      height: 60,
      marginRight: isDesktop ? 20 : 10
    }
  }

  const goToLoads = () => {
    navigation.navigate('loads', { screen: 'all' })
  }

  const goToOffers = () => {
    navigation.navigate('offers', { screen: 'myOffers' })
  }

  const goToOrders = () => {
    navigation.navigate('orders', { screen: 'assigned' })
  }

  return (
    <View style={styles.container}>
      <View
        style={[
          styles.column,
          {
            marginBottom: isDesktop ? 20 : 10
          }
        ]}
      >
        <SkeletonContent
          containerStyle={skeleton.firstContainer}
          isLoading={loading}
          layout={[
            skeleton.card,
            skeleton.card
          ]}
        >
          <QuickNumberCard
            title='All available loads'
            number={quickNumbers.all_available_loads}
            onPress={goToLoads}
            style={[
              styles.cardContainer,
              {
                marginRight: isDesktop ? 20 : 10
              }
            ]}
            testID='dashboardAllLoadsQuickNumber'
          />
          <QuickNumberCard
            title='My available offers'
            number={quickNumbers.my_available_offers}
            onPress={goToOffers}
            style={[
              styles.cardContainer,
              {
                marginRight: isDesktop ? 20 : 0
              }
            ]}
            testID='dashboardMyOffersQuickNumber'
          />
        </SkeletonContent>
      </View>
      <View style={styles.column}>
        <SkeletonContent
          containerStyle={skeleton.secondContainer}
          isLoading={loading}
          layout={[
            skeleton.card,
            skeleton.card
          ]}
        >
          <QuickNumberCard
            title='Order pickup'
            number={quickNumbers.order_pickup}
            onPress={goToOrders}
            style={[
              styles.cardContainer,
              {
                marginRight: isDesktop ? 20 : 10
              }
            ]}
            testID='dashboardPickupQuickNumber'
          />
          <QuickNumberCard
            title='Order delivery'
            number={quickNumbers.order_delivery}
            onPress={goToOrders}
            style={styles.cardContainer}
            testID='dashboardDeliveryQuickNumber'
          />
        </SkeletonContent>
      </View>
    </View>
  )
}

const useStyles = (isDesktop) => StyleSheet.create({
  container: {
    marginVertical: 10,
    flexDirection: isDesktop ? 'row' : 'column'
  },
  column: {
    flex: 1,
    flexDirection: isDesktop ? 'column' : 'row'
  },
  cardContainer: {
    flex: 1
  }
})

QuickNumbers.propTypes = {
  quickNumbers: PropTypes.object.isRequired,
  loading: PropTypes.bool
}

QuickNumbers.defaultProps = {
  quickNumbers: {},
  loading: false
}

export default QuickNumbers
